import { UIUpdate } from "../UI/UIUpdate";

interface FeatureFlags{
    _enableAnimations : boolean
}

class FeatureFlagsHolder implements FeatureFlags{
    _enableAnimations = false
    get enableAnimations(): boolean{
        return this._enableAnimations;
    }
    set enableAnimations(value: boolean){
        this._enableAnimations = value;
        UIUpdate.notifyFeatureFlagChangeListeners();
    }
}

export let featureFlags = new FeatureFlagsHolder();